<template>
  <div class="app" v-cloak>
    <router-view/>
    <hot-footer :show="show"/>
  </div>
</template>
<script>
import Notice from "@/components/Notice.vue"
import axios from "axios"

export default {
  name: "App",
  data() {
    return {
      show: "index"
    }
  },
  components: {
    Notice
  },
  created(){
    const lang = this.$getLanguage()
    document.querySelector('html').setAttribute('lang', lang)
    document.querySelector('body').className = lang
    localStorage.setItem('language', lang)
    axios.defaults.headers.common['Accept-Language'] = lang
  },
  watch: {
    $route: function(route, oldRoute) {
      if(this.$utils.isDevEnv){
        console.log("Route changed. New: ",route,", Old: ",oldRoute)
      }
      if(this.$route.path == "/index") {
        this.show = "index"
      } else if(this.$route.path == "/authmanage/list" || this.$route.path == "/authmanage" || this.$route.path == "/download" || this.$route.path == "/docs") {
        this.show = ""
      } else {
        this.show = "noIndex"
      }
      this.$utils.setStorage("lastUrl",oldRoute.path)
    },
    "$i18n.locale": function(lang) {
      document.querySelector('html').setAttribute('lang', lang)
      document.querySelector('body').className = lang
      localStorage.setItem('language', lang)
      axios.defaults.headers.common['Accept-Language'] = lang
      //不需要刷新页面
      //window && window.location.reload();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue